import { useTranslations } from 'next-intl'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import BedtimeOutlinedIcon from '@mui/icons-material/BedtimeOutlined'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'

interface NightTimeModeButtonProps {
  toggleNightMode: () => void
  selectedTheme: string
}

function NightTimeModeButton (props: NightTimeModeButtonProps) {
  const t = useTranslations('header')

  return (
    <Tooltip title={`${t('night-mode')} (${t('beta')})`}>
      <IconButton
        onClick={() => props.toggleNightMode()}
        size="small"
        sx={{
          ml: 2,
          boxShadow: 'var(--default-box-shadow)'
        }}
      >
        {props.selectedTheme === 'dark' && <LightModeOutlinedIcon />}
        {props.selectedTheme != 'dark' && <BedtimeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  )
}

export default NightTimeModeButton
